// extracted by mini-css-extract-plugin
export var desktopTopicsMenu = "topics-menu-module--desktopTopicsMenu--2425a";
export var mobileTopicsMenu = "topics-menu-module--mobileTopicsMenu--c88aa";
export var mobileTopicsMenuInput = "topics-menu-module--mobileTopicsMenuInput--739c6";
export var mobileTopicsMenuItem = "topics-menu-module--mobileTopicsMenuItem--98236";
export var selectArrow = "topics-menu-module--selectArrow--f4c2c";
export var topicsMenu = "topics-menu-module--topicsMenu--144e9";